import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const paymentModeModURL = "api/v1/core-app/payment-mode";
//obtaining the paginated data
export const getPaymentMode = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${paymentModeModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPaymentMode = () => axiosInstance.get(`${paymentModeModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePaymentMode = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${paymentModeModURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`);

//creating function
export const createPaymentMode = (body) => axiosInstance.post(`${paymentModeModURL}/create`, body);
//updating function
export const updatePaymentMode = (id, body) => axiosInstance.patch(`${paymentModeModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) =>
  axiosInstance.get(`${paymentModeModURL}/list?ordering=${sortOrder}&offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataPaymentModeName = (e, cancelToken) =>
  axiosInstance.get(`${paymentModeModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
